import React from "react";
import DocumentVerify from "./DocumentVerify";

function App() {
  return (
    <div className="App">
      <DocumentVerify />
    </div>
  );
}

export default App;
